import { render, staticRenderFns } from "./MatchUpdate.vue?vue&type=template&id=26f2dcac&"
import script from "./MatchUpdate.vue?vue&type=script&lang=js&"
export * from "./MatchUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports